<div class="charge">
    <form [formGroup]="model" novalidate>
        <div class="form-group">
            <label>
                Reason for edit
            </label>
            <input class="form-control" formControlName="reason"
                   placeholder="Reason ..." type="text"/>

            <div class="d-flex mt-3 text-muted">
                <mat-icon class="mr-2">info</mat-icon>
                <span>
                Fields that are left blank will keep their current value. Only fill in the fields you wish to update for
                all selected charges.
                </span>
            </div>
        </div>
        <div class="grid-layout grid-2">
            <div>
                <div class="form-group">
                    <label>
                        Charge Title*
                    </label>
                    <!--suppress HtmlUnknownAttribute -->
                    <input autofocus class="form-control"
                           placeholder="Charge title..."
                           formControlName="title" type="text"/>
                    <lf-control-messages [control]="model.controls['title']"></lf-control-messages>
                </div>

                <div class="form-group">
                    <label>
                        Charge Description*
                    </label>
                    <!--suppress HtmlUnknownAttribute -->
                    <textarea class="form-control" formControlName="description" rows="7" placeholder="Charge description..."></textarea>
                    <lf-control-messages [control]="model.controls['description']"></lf-control-messages>
                </div>

                <div class="form-group">
                    <label matTooltip="This message appears at the bottom of invoice emails to provide additional information">
                        Charge Message (optional)
                    </label>
                    <!--suppress HtmlUnknownAttribute -->
                    <textarea class="form-control" formControlName="emailAppendMessage" rows="5" placeholder="Optional message..."></textarea>
                    <lf-control-messages [control]="model.controls['emailAppendMessage']"></lf-control-messages>
                </div>
            </div>
            <div>
                <div class="form-group">
                    <label>
                        Amount*
                    </label>
                    <lf-currency [showSymbol]="true" formControlName="chargeAmount" validateDecimal>
                    </lf-currency>
                    <lf-control-messages [control]="model.controls['chargeAmount']"></lf-control-messages>
                </div>

                <div class="form-group">
                    <label>Active Date*</label>
                    <input
                        (click)="activeDate.open()"
                        [matDatepicker]="activeDate"
                        class="form-control date d-inline-block"
                        color="accent"
                        [matDatepickerFilter]="filterActiveAfter"
                        formControlName="activeAfter"
                        placeholder="Active date..."
                    />
                    <mat-datepicker #activeDate></mat-datepicker>
                    <lf-control-messages [control]="model.controls['activeAfter']"></lf-control-messages>
                </div>

                <div class="form-group">
                    <label>
                        Due Date*
                    </label>
                    <input
                        (click)="paymentDueOn.open()"
                        [matDatepicker]="paymentDueOn"
                        class="form-control date d-inline-block"
                        color="accent"
                        [matDatepickerFilter]="filterDueDate"
                        formControlName="paymentDueOn"
                        placeholder="Due date..."
                    />
                    <mat-datepicker #paymentDueOn></mat-datepicker>
                    <lf-control-messages [control]="model.controls['paymentDueOn']"></lf-control-messages>
                </div>


                <div class="form-group">
                    <label>
                        Deposit Bank Account*
                    </label>
                    <app-deposit-account-selector [controlName]="'depositBankAccount'" [formGroup]="model"></app-deposit-account-selector>
                    <lf-control-messages [control]="model.controls['depositBankAccount']"></lf-control-messages>
                </div>

                <div class="form-group">
                    <label>Revenue Category*</label>
                    <app-category-select [organizationId]="organizationId" [formGroup]="model" [controlName]="'category'" [showExpenseCategories]="false" [showAssets]="false" [showLiabilities]="false" [showEquities]="false"></app-category-select>

                    <lf-control-messages [control]="model.controls['category']"></lf-control-messages>
                </div>
            </div>
        </div>

        <div class="row pb-2">
            <div class="col-sm-6 col-xs-12">
                <label>
                    <input [value]="true"
                           class="custom-checkbox"
                           formControlName="emailInvoice"
                           type="radio"/>
                    <span></span>
                    Email Invoice on Active Date
                </label>
            </div>
            <div class="col-sm-6 col-xs-12">
                <label>
                    <input [value]="false"
                           class="custom-checkbox"
                           formControlName="emailInvoice"
                           type="radio"/>
                    <span></span>
                    Do Not Email Invoice
                </label>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <label for="earlyBefore">Early Payment Discount</label>
                <div class="row">
                    <div class="col-sm-6 col-xs-12">
                        <div [hidden]="model.get('removeEarlyDiscounts').value" class="form-group row no-gutters">
                            <span class="col-sm-3">
                                <lf-currency [min]="0" [showSymbol]="true" formControlName="earlyDiscount" validateDecimal>
                                </lf-currency>
                                <lf-control-messages [control]="model.controls['earlyDiscount']"></lf-control-messages>
                            </span>

                            <span class="col-sm-4 pt-2 text-center" style="font-size: 13px;">
                                if paid in full by
                            </span>

                            <span class="col-sm-5">

                                <input
                                    (click)="earlyBefore.open()"
                                    [matDatepicker]="earlyBefore"
                                    class="form-control date d-inline-block"
                                    color="accent"
                                    [matDatepickerFilter]="filterEarlyBefore"
                                    formControlName="earlyBefore"
                                    placeholder="Due date..."
                                />
                                <mat-datepicker #earlyBefore></mat-datepicker>
                                <lf-control-messages [control]="model.controls['earlyBefore']"></lf-control-messages>
                            </span>
                        </div>
                    </div>

                    <div class="col-sm-6 col-xs-12">
                        <div class="checkbox-cell">
                            <label>
                                <input class="custom-checkbox"
                                       formControlName="removeEarlyDiscounts"
                                       type="checkbox"/>
                                <span></span>
                                Remove early discounts?
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <label>
                    Late Fees
                </label>

                <div [hidden]="model.get('removeLateFees').value">
                    <ng-container formArrayName="lateFees">
                        <ng-container *ngFor="let lateFee of lateFees.controls; let i = index">
                            <ng-container [formGroupName]="i">
                                <div class="pt-2 row">
                                    <div class="col-8">
                                        <div class="form-check form-check-inline">
                                            <label>
                                                <input (change)="updateLateFeeType(lateFee, 'one-time');"
                                                       [value]="'one-time'"
                                                       class="custom-checkbox"
                                                       formControlName="lateFeeType"
                                                       type="radio">
                                                <span></span>
                                                One-Time Late Fee
                                            </label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <label>
                                                <input (change)="updateLateFeeType(lateFee, 'recurring');"
                                                       [value]="'recurring'"
                                                       class="custom-checkbox"
                                                       formControlName="lateFeeType"
                                                       type="radio">
                                                <span></span>
                                                Recurring Late Fee
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-4 text-right">
                                        <a (click)="removeLateFee(i);" class="btn--remove-fee">
                                            <i class="fa fa-remove"></i>
                                        </a>
                                    </div>
                                </div>

                                <div *ngIf="lateFee.get('lateFeeType').value === 'one-time'" class="row pb-2">
                                    <div class="col-sm-3 col-xs-12">
                                        <label for="Fee-{{i}}-Calculation">Fee Calculation</label>
                                        <br>
                                        <select class="custom-select"
                                                formControlName="oneTimeLateFeeType"
                                                id="Fee-{{i}}-Calculation">
                                            <option [selected]="lateFee.get('oneTimeLateFeeType').value === 'flat'"
                                                    value="flat">Flat Amount
                                            </option>
                                            <option
                                                [selected]="lateFee.get('oneTimeLateFeeType').value === 'interest-simple'"
                                                value="interest-simple">Percentage of Charge Balance
                                            </option>
                                            <option
                                                [selected]="lateFee.get('oneTimeLateFeeType').value === 'interest-compound'"
                                                value="interest-compound">Percentage of Charge Balance + Fees
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-sm-3 col-xs-12">
                                        <label for="Fee-{{i}}-Value">
                                            Fee Amount
                                        </label>
                                        <br>
                                        <lf-currency *ngIf="lateFee.get('oneTimeLateFeeType').value === 'flat'"
                                                     [min]="0"
                                                     [showSymbol]="true" formControlName="oneTimeLateFeeAmount"
                                                     id="Fee-{{i}}-Value" validateDecimal>
                                        </lf-currency>

                                        <lf-percentage *ngIf="lateFee.get('oneTimeLateFeeType').value !== 'flat'"
                                                       [min]="0"
                                                       [showSymbol]="true" formControlName="oneTimeLateFeeAmount"
                                                       id="Fee-{{i}}-Value" validateDecimal>
                                        </lf-percentage>

                                        <lf-control-messages [control]="lateFee.get('oneTimeLateFeeAmount')"></lf-control-messages>
                                    </div>

                                    <div class="col-xs-12 col-sm-3 date-has-width">
                                        <label>
                                            applies on
                                        </label>
                                        <input
                                            (click)="oneTimeLateFeeApplies.open()"
                                            [matDatepicker]="oneTimeLateFeeApplies"
                                            class="form-control date d-inline-block"
                                            color="accent"
                                            [matDatepickerFilter]="filterLateFeeApplication"
                                            formControlName="oneTimeLateFeeApplies"
                                            placeholder="Applies on..."
                                        />
                                        <mat-datepicker #oneTimeLateFeeApplies></mat-datepicker>

                                        <lf-control-messages [control]="lateFee.get('oneTimeLateFeeApplies')">
                                        </lf-control-messages>
                                    </div>

                                    <div class="col-xs-12 col-sm-3">
                                        <label>late fee category</label>
                                        <app-category-select [organizationId]="organizationId" [formGroup]="lateFee" [showExpenseCategories]="false" [showEquities]="false" [showAssets]="false" [showLiabilities]="false" [controlName]="'category'"></app-category-select>
                                        <lf-control-messages [control]="lateFee.get('category')">
                                        </lf-control-messages>
                                    </div>
                                </div>

                                <div *ngIf="lateFee.get('lateFeeType').value === 'recurring'" class="row pb-2">
                                    <div class="col-xs-12 col-sm-4">
                                        <label for="Fee-{{i}}-Calculation">Fee Calculation</label>
                                        <br>
                                        <select
                                            class="custom-select"
                                            formControlName="recurringLateFeeType">
                                            <option [selected]="lateFee.get('recurringLateFeeType').value === 'flat'"
                                                    value="flat">Flat Amount
                                            </option>
                                            <option
                                                [selected]="lateFee.get('recurringLateFeeType').value === 'interest-simple'"
                                                value="interest-simple">Percentage of Balance
                                            </option>
                                            <option
                                                [selected]="lateFee.get('recurringLateFeeType').value === 'interest-compound'"
                                                value="interest-compound">Percentage of Balance + Fees
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-xs-12 col-sm-4">
                                        <label for="Fee-{{i}}-Value">
                                            Fee amount
                                        </label>
                                        <br>
                                        <lf-currency *ngIf="lateFee.get('recurringLateFeeType').value === 'flat'"
                                                     [min]="0"
                                                     [showSymbol]="true" formControlName="recurringLateFeeAmount"
                                                     validateDecimal></lf-currency>

                                        <lf-percentage *ngIf="lateFee.get('recurringLateFeeType').value !== 'flat'"
                                                       [min]="0"
                                                       [showSymbol]="true" formControlName="recurringLateFeeAmount"
                                                       id="Fee-{{i}}-Value" validateDecimal>
                                        </lf-percentage>
                                    </div>

                                    <div class="col-xs-12 col-sm-4 date-has-width">
                                        <label>First applies on</label>
                                        <br>
                                        <input
                                            (click)="recurringLateFeeBegins.open()"
                                            [matDatepicker]="recurringLateFeeBegins"
                                            [min]="minimumLatePaymentDate"
                                            class="form-control date d-inline-block"
                                            formControlName="recurringLateFeeBegins"
                                            placeholder="MM/DD/YYYY"
                                        />
                                        <mat-datepicker #recurringLateFeeBegins></mat-datepicker>

                                        <lf-control-messages [control]="lateFee.get('recurringLateFeeBegins')">
                                        </lf-control-messages>
                                    </div>


                                    <div class="col-xs-12 col-sm-6">
                                        <label>and repeats every</label>
                                        <br>
                                        <div class="input-group">
                                            <input class="form-control percentage"
                                                   formControlName="recurringLateFeeIntervalValue" minlength="1"
                                                   placeholder=""
                                                   type="text"/>

                                            <select
                                                class="custom-select"
                                                formControlName="recurringLateFeeInterval">
                                                <option
                                                    [selected]="lateFee.get('recurringLateFeeInterval').value === 'days'"
                                                    value="days">days
                                                </option>
                                                <option
                                                    [selected]="lateFee.get('recurringLateFeeInterval').value === 'weeks'"
                                                    value="weeks">weeks
                                                </option>
                                                <option
                                                    [selected]="lateFee.get('recurringLateFeeInterval').value === 'months'"
                                                    value="months">months
                                                </option>
                                                <option
                                                    [selected]="lateFee.get('recurringLateFeeInterval').value === 'years'"
                                                    value="years">years
                                                </option>
                                            </select>
                                        </div>
                                        <lf-control-messages [control]="lateFee.get('recurringLateFeeIntervalValue')">
                                        </lf-control-messages>
                                    </div>

                                    <div class="col-xs-12 col-sm-6">
                                        <label>late fee category</label>
                                        <app-category-select [formGroup]="lateFee" [showExpenseCategories]="false" [showEquities]="false" [showAssets]="false" [showLiabilities]="false" [controlName]="'category'"></app-category-select>
                                        <lf-control-messages [control]="lateFee.get('category')">
                                        </lf-control-messages>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>

                <div class="row">
                    <div class="col-6">
                        <a (click)="newLateFeeModel()" [hidden]="model.get('removeLateFees').value" class="btn px-0 btn-link">Add
                            Late
                            Fee</a>
                    </div>
                    <div class="col-6">
                        <label>
                            <input (change)="clearLateFeeControls();" class="custom-checkbox"
                                   formControlName="removeLateFees" type="checkbox"/>
                            <span></span>
                            Remove late fees?
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
